module.exports = function () {
  var win_H=$(window).height();
  var win_W=$(window).width();
  $(".main").height(win_H);
  var old_case = 0;
  if(win_W<1450){
    $(".left").css("left","-408px");
    $(".right").css("margin-left","60px")
  }
  window.chage_nav=function(num){
    if(!$(".main").is(":animated")){
      $(".list").removeClass("animate");
      setTimeout(function(){
        $(".list").eq(num).addClass("animate");
      },400);

      $(".main").animate({left:-100*num+'%'},500);
      old_case=num;
      popupClose()
    }
  };
  window.M_scroll=function(Direction){
    if(Direction){
      if(old_case!=0){
        chage_nav(old_case-1);
      }
      old_case-1;
    }else{
      if(old_case!=4){
        chage_nav(old_case+1);
      }
      old_case+1;
    }
  };
  $(function(){
    chage_nav(0);
    $(window).resize(function(){
      win_H=$(window).height();
      win_W=$(window).width();
      $(".main").height(win_H);
      if(win_W<1450){
        $(".left").css("left","-408px");
        $(".right").css("margin-left","60px")
      }else {
        $(".left ,.right").attr("style","");
      }
      //win_H=$(window).height();
    });
    var scrollFunc=function(e){
      e=e || window.event;
      if(e.detail){
        if(e.detail>0){//Firefox
          M_scroll(false)
          //向下
        }else{
          M_scroll(true)
          //向上
        }
      }else{
        if(e.wheelDelta>0){//IE/Opera/Chrome
          M_scroll(true)
          //向上
        }else{
          M_scroll(false)
          //向下
        }
      }
    };
    /*注册事件*/
    if(document.addEventListener){
      document.addEventListener('DOMMouseScroll',scrollFunc,false);
    }//W3C
    document.onmousewheel=scrollFunc;
//IE/Opera/Chrome
  });
};